module.exports = __webpack_public_path__ + "static/img/study_bg.0ed96ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/study_bg.png
// module id = UxN/
// module chunks = 1